import { LogFirebase } from "../../../../../services/firestore";
import { showMeRoomTypeIsGoRoomOrP2P } from "../../../twilioCallUtility";
import { setLocalUserNetworkQuality } from "../../../../../reducers/twilioEvents-reducer";
import reduxStore from "../../../../../configureEnvStore";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { setCallParticipants } from "../../../../../reducers/common-reducer";
import { handleShowNetworkUnstableView } from "../../../../Network/NetworkUtils";

export const localNetworkQualityLevelChanged = (participant) => {
    const { callParticipants } = reduxStore.getState().commonReducer;
    const { joinMeetingData } = reduxStore.getState().joinMeeting;
    if (participant) {
        console.log("local_participant_networkdata-", participant.networkQualityLevel);
        if (!showMeRoomTypeIsGoRoomOrP2P(joinMeetingData?.sessionConfigurations)) {
            reduxStore.dispatch(setLocalUserNetworkQuality(participant.networkQualityLevel));
            if (GLOBAL_MEETING_DATA.ucid) {
                const updatedParticipants = callParticipants.map((user) => {
                    if (user.identity == CALL_DATA.localIdentity) {
                        return { ...user, networkQuality: participant.networkQualityLevel };
                    }
                    return user;
                });
                reduxStore.dispatch(setCallParticipants(updatedParticipants));
            }
            LogFirebase("NetworkQuality", "network_quality_level_changed", participant.networkQualityLevel);
            handleShowNetworkUnstableView(participant.networkQualityLevel, "local");
        }
    }
};
